module.exports = __webpack_public_path__ + "static/media/inc_stamp.dd4b4e25.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/inc_stamp.png
// module id = 391
// module chunks = 0